'use client';
import React, { useState } from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import AppDownloadModal from '@/components/AppDownloadModal';
import HeroSection from './HeroSection';
import StatsBar from './StatsBar';
import HowItWorksSection from './HowItWorksSection';
import FeaturedCampaigns from './FeaturedCampaigns';
import TestimonialsSection from './TestimonialsSection';
import AppDownloadCTA from './AppDownloadCTA';

export default function HomepageClient() {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <>
      <Header onDownloadClick={() => setModalOpen(true)} />
      <main>
        <HeroSection onCTAClick={() => setModalOpen(true)} />
        <StatsBar />
        <HowItWorksSection />
        <FeaturedCampaigns onReviewClick={() => setModalOpen(true)} />
        <TestimonialsSection />
        <AppDownloadCTA onDownloadClick={() => setModalOpen(true)} />
      </main>
      <Footer />
      <AppDownloadModal isOpen={modalOpen} onClose={() => setModalOpen(false)} />
    </>
  );
}